import { useEffect, useState } from "react";

export default function CookieConsent({ t, open, onClose, consent, onSave }) {
  const [statistics, setStatistics] = useState(
    consent ? consent.statistics : false,
  );
  const [map, setMap] = useState(consent ? consent.map : false);
  const [settings, setSettings] = useState(open && consent !== null);

  useEffect(() => {
    setStatistics(consent ? consent.statistics : false);
    setMap(consent ? consent.map : false);
    setSettings(open && consent !== null);
  }, [open, consent]);

  if (!open) return null;

  return (
    <div className="cookie-dock" role="dialog" aria-labelledby="cookie-title">
      <div className="glass cookie-panel">
        <p className="kicker">MENSTAGE</p>
        <h2 id="cookie-title">{t.cookieTitle}</h2>
        <p className="lead">{t.cookieLead}</p>
        {settings ? (
          <div className="cookie-choices">
            <label>
              <input
                type="checkbox"
                checked={statistics}
                onChange={(event) => setStatistics(event.target.checked)}
              />
              <span>
                <strong>{t.cookieStats}</strong>
                <small>{t.cookieStatsHelp}</small>
              </span>
            </label>
            <label>
              <input
                type="checkbox"
                checked={map}
                onChange={(event) => setMap(event.target.checked)}
              />
              <span>
                <strong>{t.cookieMap}</strong>
                <small>{t.cookieMapHelp}</small>
              </span>
            </label>
          </div>
        ) : null}
        <div className="cookie-actions">
          {settings ? (
            <button
              type="button"
              className="btn btn-gold btn-sm"
              onClick={() => onSave({ statistics, map })}
            >
              {t.cookieSave}
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-gold btn-sm"
              onClick={() => onSave({ statistics: true, map: true })}
            >
              {t.cookieAccept}
            </button>
          )}
          <button
            type="button"
            className="btn btn-glass btn-sm"
            onClick={() => onSave({ statistics: false, map: false })}
          >
            {t.cookieNecessary}
          </button>
          {settings ? (
            <button
              type="button"
              className="btn btn-glass btn-sm"
              onClick={() => (consent ? onClose() : setSettings(false))}
            >
              {consent ? t.close : t.cookieBack}
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-glass btn-sm"
              onClick={() => setSettings(true)}
            >
              {t.cookieSettings}
            </button>
          )}
        </div>
        <p className="cookie-note">
          <a href="/cookie-tajekoztato/">{t.footCookie}</a>
        </p>
      </div>
    </div>
  );
}
